import { render } from "./toronto.vue?vue&type=template&id=70d86660&scoped=true"
import script from "./toronto.vue?vue&type=script&lang=js"
export * from "./toronto.vue?vue&type=script&lang=js"

import "./toronto.vue?vue&type=style&index=0&id=70d86660&lang=scss&scoped=true"
import "./toronto.vue?vue&type=style&index=1&id=70d86660&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70d86660"

export default script